const QueueStatuses = {
  IN_PROGRESS: 'inProgress',
  QUEUE: 'queue',
  RECLAIM_START: 'reclaimStart',
  RECLAIM_END: 'reclaimEnd',
  ACK: 'ack',
  BATCH_QUEUE: 'batchQueue',
};

export { QueueStatuses };
